export const languageOptions = [
    { key: 'en', value: 'en', flag: 'gb', text: 'English' },
    { key: 'zh', value: 'zh', flag: 'cn', text: '中文 (Chinese)' },
    { key: 'es', value: 'es', flag: 'es', text: 'Español (Spanish)' },
    { key: 'hi', value: 'hi', flag: 'in', text: 'हिन्दी (Hindi)' },
    { key: 'ar', value: 'ar', flag: 'sa', text: 'العربية (Arabic)' },
    { key: 'pt', value: 'pt', flag: 'pt', text: 'Português (Portuguese)' },
    { key: 'ru', value: 'ru', flag: 'ru', text: 'Русский (Russian)' },
    { key: 'bn', value: 'bn', flag: 'bd', text: 'বাংলা (Bengali)' },
    { key: 'fr', value: 'fr', flag: 'fr', text: 'Français (French)' },
    { key: 'de', value: 'de', flag: 'de', text: 'Deutsch (German)' },
    { key: 'ja', value: 'ja', flag: 'jp', text: '日本語 (Japanese)' },
    { key: 'ur', value: 'ur', flag: 'pk', text: 'اردو (Urdu)' },
    { key: 'ro', value: 'ro', flag: 'ro', text: 'Română (Romanian)' },
    { key: 'it', value: 'it', flag: 'it', text: 'Italiano (Italian)' },
    { key: 'hu', value: 'hu', flag: 'hu', text: 'Magyar (Hungarian)' },
    { key: 'el', value: 'el', flag: 'gr', text: 'Ελληνικά (Greek)' },
    { key: 'tr', value: 'tr', flag: 'tr', text: 'Türkçe (Turkish)' },
    { key: 'sr', value: 'sr', flag: 'rs', text: 'Српски (Ћирилица)' },
    { key: 'srLatn', value: 'srLatn', flag: 'rs', text: 'Srpski (Latinica)' }
  ];